.highlightText {
  @include themify($themes) {
    background-color: themed("tvs-yellow");
  }
}
